export default __webpack_public_path__ + "static/media/background-pattern-3.fe666c17.svg";